// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 878) return "static/chunks/878-de00860b1a5bdafb.js";
	if (chunkId === 4762) return "static/chunks/52271efe-d3d9607764ee62c9.js";
	if (chunkId === 5744) return "static/chunks/5744-7168ec42ffb0d092.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1954":"c723e6bd81119877","4349":"596192a0ec2f7214","6009":"d35b6ce1ef3f409e","6500":"c8393ff8896d9823","6796":"9833ba4e2bc25736","7188":"97b881c9752818e7","8652":"9868e45bf0aff9ef","8954":"2b6c39e6280d4efc"}[chunkId] + ".js";
};